import AccidentallyInLove from "./Songs/AccidentallyInLove";
import Fearless from "./Songs/Fearless";
import FragileHeart from "./Songs/FragileHeart";
import HeroToMe from "./Songs/HeroToMe";
import HomecomingQueen from "./Songs/HomecomingQueen";
import KeepOnKeepingOn from "./Songs/KeepOnKeepingOn";
import ProdigalSon from "./Songs/ProdigalSon";
import SearchingForYou from "./Songs/SearchingForYou";
import SparksFly from "./Songs/SparksFly";
import Strong from "./Songs/Strong";
import TheGame from "./Songs/TheGame";
import YouBelongWithMe from "./Songs/YouBelongWithMe";

export const lyricMap = {
    1: KeepOnKeepingOn,
    2: SearchingForYou,
    3: FragileHeart,
    4: Strong,
    5: TheGame,
    6: HeroToMe,
    7: ProdigalSon,
    8: Fearless,
    9: YouBelongWithMe,
    10: HomecomingQueen,
    11: SparksFly,
    12: AccidentallyInLove,
}